import request from "../request";

export default {
  // 前台-频道列表
  indexLoad(data) {
    return request.get("/city/indexLoad", data);
  },

  // 查询可访问城市
  cityList(data) {
    return request.get("/city/cityList", data);
  },

  // 频道详情
  plateInfo(data) {
    return request.get("/city/plateInfo", data);
  }
};
